import { Check, Copy, Share2 } from 'lucide-react'
import { useEffect, useState } from 'react'
import { referralsApi } from '../../api/endpoints'
import type { ReferralResponse } from '../../types/api'

/**
 * One referral code per participant is enough for an invite link; if they already have codes we
 * show the first rather than minting another on every visit.
 */
export function InviteCard() {
  const [referral, setReferral] = useState<ReferralResponse | null>(null)
  const [copied, setCopied] = useState(false)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    let cancelled = false
    referralsApi
      .listOwn()
      .then(async (list) => (list.length ? list[0] : referralsApi.create({ sourceChannel: 'profile' })))
      .then((r) => {
        if (!cancelled) setReferral(r)
      })
      .catch(() => {
        if (!cancelled) setFailed(true)
      })
    return () => {
      cancelled = true
    }
  }, [])

  const link = referral ? `${window.location.origin}/register?ref=${referral.referralCode}` : ''

  async function copy() {
    if (!link) return
    try {
      await navigator.clipboard.writeText(link)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch {
      setFailed(true)
    }
  }

  return (
    <div className="card-pad">
      <h2 className="flex items-center gap-2 font-bold text-ink-900">
        <Share2 size={16} className="text-ink-400" /> Invite to YellowDots
      </h2>
      <p className="mt-1 text-sm text-ink-500">
        Every person you invite makes the map more useful for your area.
      </p>

      {failed && !referral ? (
        <p className="mt-3 text-sm text-ink-500">Your invite link is not available right now.</p>
      ) : (
        <>
          <div className="mt-3 truncate rounded-xl border border-ink-200 bg-ink-50 px-3 py-2 text-xs text-ink-600">
            {link || 'Preparing your link...'}
          </div>
          <button onClick={copy} disabled={!link} className="btn-ghost mt-2 w-full">
            {copied ? <><Check size={15} /> Copied</> : <><Copy size={15} /> Copy invite link</>}
          </button>
          <p className="mt-2 text-center text-xs text-ink-400">
            {referral ? `${referral.uses} invited so far` : ' '}
          </p>
        </>
      )}
    </div>
  )
}
